import { REQUEST } from '../../../utils/actionGenerator';
import { fork, take } from 'redux-saga/effects';
import * as api from '../../../utils/api';
import { fetchEntity, fetchEntitySpawn } from '../../../store/saga';
import * as placementActions from './actions';
import { takeLatest } from 'redux-saga/effects';
import { all, call, put } from 'redux-saga/effects';
import { SET_LOADER } from 'components/App/store/actions';
import store from 'store/configureStore';

export function* getTicketListTicket(params) {
  const request = api.indentsListRequestTicket.bind(null, params);
  yield fetchEntity(request, placementActions.getIndentsList, params);
}

export function* getEmailsList(params) {
  const request = api.getEmailsListRequestTicket.bind(null, params);
  yield fetchEntity(request, placementActions.getEmailsList, params);
}

export function* getBasicDetails(consignmentId) {
  const request = api.getBasicDetailsRequestTicket.bind(null, consignmentId);
  yield fetchEntity(request, placementActions.getBasicDetails, consignmentId);
}

export function* addNewTicketSaga(actions) {
  const request = api.addNewTicketApi(actions.payload);
  yield fetchEntitySpawn(request, placementActions.addNewTicket, actions.payload);
}

export function* updateTicketDetails(actions) {
  const request = api.updateTicketDetailsApi(actions.payload);
  yield fetchEntitySpawn(request, placementActions.updateTicketDetails, actions.payload.payload);
}

export function* getTicketDetailPageDetails(actions) {
  const request = api.getTicketDetailsPageDetailApi(actions.payload);
  yield fetchEntitySpawn(request, placementActions.getTicketDetailPageDetails, actions.payload);
}

export function* addNewCommentFun(actions) {
  const request = api.addNewCommentApi(actions.payload);
  yield fetchEntitySpawn(request, placementActions.addNewComment, actions.payload.payload);
}

export function* getConversationFun(actions) {
  const request = api.getConversationListApi(actions.payload);
  yield fetchEntitySpawn(request, placementActions.getConversation, actions.payload);
}

export function* getCommentsList(actions) {
  const request = api.getComments(actions.payload);
  yield fetchEntitySpawn(request, placementActions.getComments, actions.payload);
}

export function* getDetailsConfig(actions) {
  const request = api.getDetailsConfigRequest(actions.payload);
  yield fetchEntitySpawn(request, placementActions.getDetailsConfig);
}

export function* getStoppageReasons() {
  const request = api.getStoppageReasons();
  yield fetchEntitySpawn(request, placementActions.getStoppageReason);
}

export function* getTicketingEntities(ticketId) {
  const request = api.getTicketEntitiesRequest.bind(null, ticketId);
  yield fetchEntity(request, placementActions.getTicketingEntities, ticketId);
}
export function* postTicketingFields(payload) {
  const request = api.postTicketEntitiesRequest.bind(null, payload);
  yield fetchEntity(request, placementActions.postTicketingFields, payload);
}

export function* watchGetIndentsListSagaT() {
  while (true) {
    const { params } = yield take(placementActions.GET_INDENTS_LIST_T[REQUEST]);
    yield fork(getTicketListTicket, params);
  }
}

export function* watchGetEmailsListSagaTicket() {
  while (true) {
    const { params } = yield take(placementActions.GET_EMAILS_LIST_TICKET[REQUEST]);
    yield fork(getEmailsList, params);
  }
}

export function* watchGetBasicDetailsSagaTicket() {
  while (true) {
    const { consignmentId } = yield take(placementActions.GET_BASIC_DETAILS_TICKET[REQUEST]);
    yield fork(getBasicDetails, consignmentId);
  }
}
export function* watchGetTicketingEntities() {
  while (true) {
    const {
      payload: { ticketId },
    } = yield take(placementActions.GET_TICKETING_ENTITIES[REQUEST]);
    yield fork(getTicketingEntities, ticketId);
  }
}
export function* watchPostTicketingFields() {
  while (true) {
    const { payload } = yield take(placementActions.POST_TICKETING_FIELD[REQUEST]);
    yield fork(postTicketingFields, payload);
  }
}

export function* watchUploadFileDocumentSaga() {
  while (true) {
    const { payload } = yield take(placementActions.UPLOAD_DOCUMENTS[REQUEST]);

    yield fork(uploadDocument, payload);
  }
}
export function* uploadDocument(payload) {
  const formData = {
    fileName: payload.fileName.name,
    type: payload.docType,
  };

  let requests = [api.uploadPostDocumentRequest.bind(null, formData)];
  try {
    store.dispatch({ type: SET_LOADER });
    const responses = yield all(requests.map((fn) => call(fn)));
    const uploadUrl = responses[0].data.data.url;

    if (responses) {
      const requestURL2 = uploadUrl.toString();
      const response = yield call(fetch, requestURL2, {
        headers: { Accept: 'application/json, text/plain, */*' },
        method: 'PUT',
        body: payload.fileName,
      });
      if (response.status === 200) {
        yield put(placementActions.uploadDocument.success(responses, payload));
      } else {
        throw new Error('Upload failed');
      }
    }
  } catch (err) {
    store.dispatch({ type: SET_LOADER });
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

export function* watchViewUploadedDocumentSaga2() {
  while (true) {
    const { params } = yield take(placementActions.VIEW_UPLOADED_DOCUMENT2[REQUEST]);
    yield fork(viewUploadedDocumentN, params);
  }
}
export function* viewUploadedDocumentN(params) {
  if (!!params) {
    let requests = [api.getUploadedDocumentUrlRequest2.bind(null, params)];

    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      if (params.openType == 'window') {
        if (responses[0].data.message === 'Ok') {
          window.open(responses[0].data.data.url, '_blank');
        }
      } else {
        if (responses[0].data.message === 'Ok') {
          yield put(placementActions.viewUploadedDocument2.success(responses, params));
        } else {
        }
      }
    } catch (error) {
      console.error(error, 'error');
      //log(error)
    }
  }
}

export function* getTicketsByConsignment(payload) {
  try {
    yield put({ type: SET_LOADER, payload: true });
    const response = yield call(api.getTicketsByConsignmentApi, {
      code: payload.payload.consignmentCode,
      source: payload.payload.sourceKey,
    });
    yield put(placementActions.getTicketsByConsignment.success(response.data, payload));
  } catch (error) {
    yield put(placementActions.getTicketsByConsignment.failure(error));
  } finally {
    yield put({ type: SET_LOADER, payload: false });
  }
}

export function* watchGetTicketsByConsignment() {
  while (true) {
    const { payload } = yield take(placementActions.GET_TICKETS_BY_CONSIGNMENT[REQUEST]);
    yield fork(getTicketsByConsignment, payload);
  }
}

function* ticketingSaga() {
  yield takeLatest(placementActions.ADD_NEW_TTCKET[REQUEST], addNewTicketSaga);

  yield takeLatest(placementActions.GET_TICKET_DETAILPAGE_DETAILS[REQUEST], getTicketDetailPageDetails);

  yield takeLatest(placementActions.UPDATE_TICKET_DETAILS[REQUEST], updateTicketDetails);

  yield takeLatest(placementActions.ADD_NEW_COMMENT[REQUEST], addNewCommentFun);

  yield takeLatest(placementActions.GET_CONVERSATION[REQUEST], getConversationFun);

  yield takeLatest(placementActions.GET_COMMENTS[REQUEST], getCommentsList);

  yield takeLatest(placementActions.GET_DETAILS_CONFIG[REQUEST], getDetailsConfig);
  yield takeLatest(placementActions.GET_STOPPAGE_REASONS[REQUEST], getStoppageReasons);
  yield takeLatest(placementActions.GET_TICKETS_BY_CONSIGNMENT[REQUEST], getTicketsByConsignment);
}

export default ticketingSaga;
